import logger from 'tracer'

export const Logger = logger.colorConsole()
